module.exports = __webpack_public_path__ + "img/guess_middle_nor.705c75dc.png";